export default {
  buttons: {
    signup: 'Registrieren',
    login: 'Anmelden',
  },
};
